import WelcomeStyles from "./styles"

function Welcome() {
  return <WelcomeStyles>Welcome!</WelcomeStyles>
}

export default Welcome